import React, { FC, HTMLAttributes, useCallback, useMemo } from 'react';
// import React, { FC, HTMLAttributes, useCallback } from 'react';
import { Dropdown } from 'components/ui';
import { IOption } from 'components/ui/Dropdown/Dropdown';
import styles from './SelectTags.module.scss';
import classNames from 'classnames';
import { Tags } from 'components';

export interface ISelectTags extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  value: string[];
  options: IOption[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  isFullWidthTags?: boolean;
  hasAllOption?: boolean;
  tagsLimitHeight?: number;
  disabled?: boolean;
  meta: any;
}

const SelectTags: FC<ISelectTags> = (props) => {
  const {
    meta,
    value,
    options,
    disabled,
    className,
    placeholder,
    hasAllOption,
    isFullWidthTags,
    tagsLimitHeight,
    onChange = () => {},
  } = props;
  const { error, submitError, modifiedSinceLastSubmit } = meta ?? {};
  const allOptions = useMemo(() => {
    if (hasAllOption && (options || []).length > 1 && (options[0] || {}).value !== 'all') {
      return [
        {
          label: 'global.all',
          translationKey: 'global.all',
          value: 'all',
        },
        ...options,
      ];
    }
    return options;
  }, [options, hasAllOption]);
  // const { value, options, onChange = () => {}, placeholder, isFullWidthTags, className } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.disabled]: disabled,
  });

  const handleSelectValue = useCallback(
    (selectedValue) => {
      if (selectedValue === 'all') {
        onChange(options.map((option) => option.value));
        return;
      }
      onChange([...value, selectedValue]);
    },
    [onChange, value, options]
  );

  const handleRemoveValue = useCallback(
    (valueToRemove) => {
      if (valueToRemove === 'all') {
        onChange([]);
        return;
      }
      onChange(value.filter((val) => val !== valueToRemove));
    },
    [onChange, value]
  );

  return (
    <div className={rootClassName}>
      <Dropdown
        error={error}
        value={value}
        options={allOptions}
        submitError={submitError}
        onChange={handleSelectValue}
        placeholder={placeholder}
        modifiedSinceLastSubmit={modifiedSinceLastSubmit}
        isAllSelected={hasAllOption && value?.length === options?.length}
      />
      <Tags
        isAllSelected={hasAllOption && value?.length === options?.length}
        tagsLimitHeight={tagsLimitHeight}
        tags={value}
        options={allOptions}
        onTagRemove={handleRemoveValue}
        isFullWidthTags={isFullWidthTags}
      />
    </div>
  );
};

export default SelectTags;
